import Swiper from "swiper11";
import { Autoplay } from "swiper11/modules";
import { initFancyBox } from "@common/index";

const _sem = () => {
  const pageMarker = $("._sem_");
  if (!pageMarker.length) return;
  $(function () {
    // if (window.innerWidth === 1350 || window.innerWidth === 412) {
    //   $(document).one("mousemove", () => {
    //     initFunction();
    //   });
    //   $(document).one("scroll", () => {
    //     initFunction();
    //   });
    // } else {
    //   initFunction();
    // }
    initFunction();
  });

  let initFunction = () => {

    initFunction = () => { };
    if (window.innerWidth < 1025) {
      initSwiper();
    }
    initFancyBox();
    if(window.innerWidth > 1024){
      initEvent();
    }
  };

  function initEvent() {
    copyWorkflowsItem()
  }

  function copyWorkflowsItem() {
    const item = $('.workflows .workflows-list .list:nth-child(1) li:nth-child(2n)');
    $('.list-copy').append(item.clone());
  }

  function initSwiper() {
   
    
    new Swiper('._sem_ .dominance .swiper-box .swiper', {
      modules: [Autoplay],
      spaceBetween: 25,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    });
  }
};

export default _sem;
